import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  // UncontrolledTooltip,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as crossPromotionsLeadAction from "../../store/Y3Jvc3NQcm9tb3Rpb25zTGV/actions"
import { isEmpty } from "lodash"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import { ToastContainer, toast } from "react-toastify"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import api from "helpers/Api"
import "./styles.scss"

const CrossPromotionsLead = (props) => {
  const { SearchBar } = Search

  const { dispatch, searchBtnStyle } = props
  const title = "Cross Promotions Lead"

  const specificDispatch = useDispatch()

  const [downloadLoading, setDownloadLoading] = useState(false)

  useEffect(() => {
    dispatch(crossPromotionsLeadAction.loadRecordsMetaData())

    dispatch(crossPromotionsLeadAction.loadCrossPromotions())
  }, [])

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.crossPromotionsLead
  )
  const {
    recordsMetaData = {},
    lead_details = [],
  } = permissionUpdate
  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)

  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
      responseLogin.setting &&
      responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  const [btnLoader, setBtnLoader] = useState(false)
  const [convertLead, setConvertLead] = useState(false)

  //Manage lead data
  const [crossPromotionsData, setCrossPromotionsData] = useState({
    company: [],
    leadFromDate: "",
    leadToDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [crossPromotionFilter, setCrossPromotionFilter] = useState([])
  const [columnModal, setColumnModal] = useState(false)

  const handleChange = (e) => {
    setCrossPromotionsData({
      ...crossPromotionsData,
      [e.target.name]: e.target.value,
    })
    if (e.target.name == "mobileNo") {
      setCrossPromotionsData({
        ...crossPromotionsData,
        mobileNo: e.target.value.replace(/\D/g, ""),
      })
    }
  }

  //conevrtLead modal dropdown
  const [branch, setBranch] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [companyId, setCompanyId] = useState()
  const [clientId, setClientId] = useState()
  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companyId
    )

  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies.value ? companies.value : ""
      var searchCrossPromotion = crossPromotionFilter && crossPromotionFilter.value ? crossPromotionFilter.value : ""
    var searchLeadFromDate =
      crossPromotionsData && crossPromotionsData.leadFromDate
        ? moment(crossPromotionsData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      crossPromotionsData && crossPromotionsData.leadToDate
        ? moment(crossPromotionsData.leadToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchCrossPromotion) {
      searchvalue.crossPromotionStatus = searchCrossPromotion
    }
    if (searchLeadFromDate) {
      searchvalue.crossPromotionFromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.crossPromotionToDate = searchLeadToDate
    }
    specificDispatch(crossPromotionsLeadAction.loadCrossPromotions(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setCrossPromotionFilter([])
    setCrossPromotionsData({
      fromDate: "",
      leadFromDate: "",
      leadToDate: "",
      toDate: "",
      leadNo: "",
    })
    dispatch(crossPromotionsLeadAction.loadCrossPromotions())
  }
  const [crossPromotionId, setCrossPromotionId] = useState()
  // let slNo = 0
  const manageNewLeadTable =
    lead_details && lead_details.length > 0
      ? lead_details.map((data, index) => {


        return {
          _id: data._id,
          leadId: data.leadId,
          leadData: data,
          sNo: index + 1,
          leadNo: data.leadNo,
          clientId: data.clientId,
          companyId: data.companyId ? data.companyId : "--",

          company: data.companyName ? data.companyName : "--",
          crossPromotionStatus: data.crossPromotionStatus,
          crossPromotionBy: data.crossPromotionBy,
          crossPromotionByName: data.crossPromotionByName,
          crossPromotionDate: data.crossPromotionDate
            ? moment(data.crossPromotionDate).format(`${dateFormate} hh:mm A`)
            : "",
          key: index,
        }
      })
      : []

  //pagination table data columns
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Source Lead No",
      hidden: false,
      sort: true,
      editable: false,
      // formatter: (cellContent, row) => {
      //   return (
      //     <div className={row.processStatus === "PS1" ? "disabled-button" : ""}>
      //       <Link
      //         to={{
      //           pathname: `/client-details/${row._id}`,
      //           state: {
      //             row: row.leadData,
      //             leadClientId: row.leadData,
      //             mode: "SALES",
      //           },
      //         }}
      //       >
      //         {row.leadNo}
      //         {row.processStatus === "PS1" ? (
      //           <>
      //             <i
      //               style={{ color: "grey" }}
      //               id="quoteInfo"
      //               aria-hidden="true"
      //               className="fa fa-info-circle ms-1"
      //             ></i>
      //             <UncontrolledTooltip placement="right" target="quoteInfo">
      //               This lead is not yet assigned. Please change the process
      //               status, to enable the leadNo.
      //             </UncontrolledTooltip>
      //           </>
      //         ) : (
      //           ""
      //         )}
      //       </Link>
      //     </div>
      //   )
      // },
      // csvExport: false,
      style: {
        textTransform: "uppercase",
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "company",
      text: "Company",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "crossPromotionDate",
      text: "Cross Promotion Date",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "crossPromotionByName",
      text: "Cross Promotion By",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "crossPromotionStatus",
      text: "Status",
      hidden: false,
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "convertLead",
      text: "Action",
      hidden: false,
      sort: true,
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <Button className="btn btn-info"
          disabled = {row.crossPromotionStatus == "CONVERTED"}
          onClick={() => {
            setConvertLead(true)
            setBranch([])
            setSalesUrge([])
            setCompanyId(row.companyId)
            setClientId(row.clientId)
            setCrossPromotionId(row._id)
          }}>
            Convert to Lead
          </Button>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])


  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }



  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }


  const exportToCsv = () => {
    var searchCompany = companies && companies.value ? companies.value : ""

    var searchLeadFromDate =
      crossPromotionsData && crossPromotionsData.leadFromDate
        ? moment(crossPromotionsData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      crossPromotionsData && crossPromotionsData.leadToDate
        ? moment(crossPromotionsData.leadToDate).format("YYYY-MM-DD")
        : ""
  var searchCrossPromotion = crossPromotionFilter && crossPromotionFilter.value ? crossPromotionFilter.value : ""
    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchCrossPromotion) {
      searchvalue.crossPromotionStatus = searchCrossPromotion
    }
    if (searchLeadFromDate) {
      searchvalue.crossPromotionFromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.crossPromotionToDate = searchLeadToDate
    }
    setDownloadLoading(true)
    api
      .post(`/get_crossPromotion_followup`, searchvalue)
      .then((response) => {
        const exportDataTable =
          !isEmpty(response.data.data) && response.data.data.length > 0
            ? response.data.data.map((data, index) => {


              return {
                _id: data._id,
                leadId: data.leadId,
                leadData: data,
                sNo: index + 1,
                leadNo: data.leadNo,

                companyId: data.companyId ? data.companyId : "--",

                company: data.companyName ? data.companyName : "--",
                crossPromotionStatus: data.crossPromotionStatus,
                crossPromotionBy: data.crossPromotionBy,
                crossPromotionByName: data.crossPromotionByName,
                crossPromotionDate: data.crossPromotionDate
                  ? moment(data.crossPromotionDate).format(
                    `${dateFormate} hh:mm A`
                  )
                  : "",
                key: index,
              }
            })
            : []
        setTimeout(() => {
          let headerData = [
            "SNo,Source Lead No,Company, Cross Promotion Date, Cross Promotion By,Status",
          ]

          let usersCsv =
            !isEmpty(exportDataTable) &&
            exportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                company,
                crossPromotionDate,
                crossPromotionByName,
                crossPromotionStatus,
              } = user
              acc.push([
                sNo,
                leadNo,
                company,
                crossPromotionDate,
                crossPromotionByName,
                crossPromotionStatus,
              ])
              return acc
            }, [])

          const userList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : ""
          downloadFile({
            data: [...headerData, ...userList].join("\n"),
            fileName: "CrossPromotionsLead.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  const options = {
    sizePerPage: 10,
    totalSize: lead_details.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  const updateConvertLead = () => {
    const convert_details = {

      "companyId": companyId,
      "branchId": branch.value,
      "clientId": clientId,
      "salesUrge": salesUrge.value,
      "crossPromotionId": crossPromotionId
    }
    setConvertLead(false)
    dispatch(crossPromotionsLeadAction.updateConvertLead(convert_details))
    setTimeout(() => {
      specificDispatch(crossPromotionsLeadAction.loadCrossPromotions())

      toast.success("Converted Lead Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })

    }, 1000)

  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          {/* <Row>
            <NewLeadCounter />
          </Row> */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Cross Promotions From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="leadFromDate"
                          max={crossPromotionsData.leadToDate}
                          value={crossPromotionsData.leadFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Cross Promotions To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="leadToDate"
                          min={crossPromotionsData.leadFromDate}
                          value={crossPromotionsData.leadToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Cross Promotion Status"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="crossPromotionFilter"
                          value={crossPromotionFilter}
                          onChange={(e) => setCrossPromotionFilter(e)}
                          options={[     {label:"PENDING",value:"PENDING"},
                            {label:"CONVERTED",value:"CONVERTED"},
                       
                          ]
                          }
                          placeholder="Select Cross Promotion"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row
            style={{
              zIndex: 5,
            }}
          >
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>

                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={manageNewLeadTable}
                        columns={columns}
                        search
                        exportCSV={{
                          onlyExportFiltered: true,
                          exportAll: false,
                        }}
                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-row">
                                <Col className="mb-3" md="4">
                                  <div className="d-flex flex-row ">
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                      <div
                                        className="position-relative mt-7"
                                        style={searchBtnStyle || null}
                                      >
                                        <SearchBar {...props.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </div>{" "}
                                </Col>
                                <Col md="8">
                                  <div
                                    style={{
                                      float: "right",
                                    }}
                                  >
                                    <Button
                                      className="btn btn-primary"
                                      onClick={exportToCsv}
                                      id="download"
                                      style={{
                                        backgroundColor: "#e40d8c",
                                        color: "white",
                                        border: "none",
                                        marginBottom: "20px",
                                        marginTop: "0px",
                                      }}
                                    >
                                      Download
                                    </Button>
                                  </div>
                                </Col>
                                <Col>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    striped={true}
                                    bordered={true}
                                    keyField="equipment"
                                    columns={columns}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>

                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {convertLead && (
                    <Modal size="md" show={convertLead}   >
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}

                      >
                        Convert Lead
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setConvertLead(false)}
                          ></i>
                        </span>

                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-1">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Company"}>
                                {"Branch"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="branch"
                              value={branch}
                              onChange={(e) => setBranch(e)}
                              options={branchListOptions}
                              placeholder="Select Branch"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3 mb-2">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Company"}>
                                {"Sales Urge"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="salesUrge"
                              value={salesUrge}
                              onChange={(e) => setSalesUrge(e)}
                              options={[{ label: "HOT", value: "hot" }, { label: "WARM", value: "warm" }, { label: "COLD", value: "cold" }]}
                              placeholder="Select SalesUrge"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setConvertLead(false)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => updateConvertLead()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

CrossPromotionsLead.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CrossPromotionsLead)
)
